import { Component, ElementRef, Input, OnInit, Renderer2, ViewChild } from '@angular/core';

@Component({
  selector: 'app-pizza-indicator',
  templateUrl: './pizza-indicator.component.html',
  styleUrls: ['./pizza-indicator.component.scss'],
})
export class PizzaIndicatorComponent implements OnInit {


  @Input() size: string;
  @Input() pieces: number;


  public ContainerWidth:any = '0';
  public ContainerHeight:any = '0';
  public activeClasses = [];
  public completedClasses = [];


  constructor(private renderer: Renderer2) { }

  ngOnInit() {
    
    this.ContainerWidth = this.size;
    this.ContainerHeight = this.size;

  }

  
  @ViewChild('circularprogress') myElement!: ElementRef;
  private last_animated_location = 0;
  private IntervalObject;
  animate_function(animateTo = 0){
    clearInterval(this.IntervalObject);
    let To = animateTo;
    let From = this.last_animated_location;
    let CurrentPosition = From;

    let GoUp = true;
    if(To < From){
      GoUp = false;
    }


    if(GoUp){
     this.IntervalObject = setInterval(() => {
        if(CurrentPosition <= To){
          let gradientStyle = 'conic-gradient(#f55403 0% '+CurrentPosition+'%, #E6E6E6 '+CurrentPosition+'% 100%)';
          this.renderer.setStyle(this.myElement.nativeElement, 'background', gradientStyle);
          //console.log(CurrentPosition);
          this.last_animated_location++;
          CurrentPosition++;
        }else{
          clearInterval(this.IntervalObject);
        }
      }, 25);
    }else{
      this.IntervalObject = setInterval(() => {
        if(CurrentPosition >= To){
          let gradientStyle = 'conic-gradient(#f55403 0% '+CurrentPosition+'%, #E6E6E6 '+CurrentPosition+'% 100%)';
          this.renderer.setStyle(this.myElement.nativeElement, 'background', gradientStyle);
         // console.log(CurrentPosition);
          this.last_animated_location--;
          CurrentPosition--;
        }else{
          clearInterval(this.IntervalObject);
        }
      }, 25);
    }
    

    //const gradientStyle = 'conic-gradient(#f55403 0% 50%, #E6E6E6 75% 100%)';
    //this.renderer.setStyle(this.myElement.nativeElement, 'background', gradientStyle);
    //console.log('function ran');
  }


  retFu(){
    this.pieces = 1;
    this.to_full_active();
  }
  reset(){
    let gradientStyle = 'conic-gradient(#f55403 0% 0%, #E6E6E6 0% 100%)';
    this.renderer.setStyle(this.myElement.nativeElement, 'background', gradientStyle);
    this.completedClasses  = [];
    this.activeClasses = [];
  }

  to_0(){
    this.animate_function(0);
    this.completedClasses  = [];
    if(this.pieces === 2){
      this.activeClasses = ['first-piece','second-piece'];
    }else{
      this.activeClasses = ['first-piece'];
    }
  }

  to1_4(){
    if(this.pieces === 4){
      this.animate_function(25);
      this.activeClasses = ['second-piece'];
      this.completedClasses  = ['first-piece'];
    }
  }
  
  to1_2(){
    this.animate_function(50);
    if(this.pieces === 2){
      this.activeClasses = ['third-piece','fourth-piece'];
      this.completedClasses  = ['first-piece'];
    }else{
      this.activeClasses = ['third-piece'];
      this.completedClasses  = ['first-piece','second-piece'];
    }
  }


  to3_4(){
    if(this.pieces === 4){
      this.animate_function(75);
      this.activeClasses = ['fourth-piece'];
      this.completedClasses  = ['first-piece','second-piece','third-piece'];
    }
  }


  to_1(){
    
    this.animate_function(100);
    this.completedClasses  = ['first-piece','second-piece','third-piece','fourth-piece'];
    this.activeClasses = [];
  }

  to_full_active(){
      this.animate_function(0);
      this.activeClasses = ['first-piece','second-piece','third-piece','fourth-piece'];
      this.completedClasses  = [];
  }

  make_full_instant(){
    let gradientStyle = 'conic-gradient(#f55403 0% 100%, #E6E6E6 100% 100%)';
    this.renderer.setStyle(this.myElement.nativeElement, 'background', gradientStyle);
    this.completedClasses  = ['first-piece','second-piece','third-piece','fourth-piece'];
    this.activeClasses = [];
  }



}
